import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { TeamScreen } from "../team/TeamScreen";
import { useScope } from "../auth/ScopeGate";

// File name matters: `_authed.team.tsx` nests this under the _authed layout, so it gets the
// per-session query client and a resolved scope. A bare `team.tsx` would generate a
// ROOT-level route with no ScopeGate above it, and useScope would throw.
export const Route = createFileRoute("/_authed/team")({ component: TeamRoute });

function TeamRoute() {
  const scope = useScope();
  const navigate = useNavigate();

  // UX, not security: the server refuses a site manager on every /businesses/{id}/invites call
  // anyway (business-wide route → StaffAccessRules refuses a SiteManager). This just avoids
  // showing them a screen made entirely of 403s.
  useEffect(() => {
    if (scope.role !== "Owner") void navigate({ to: "/" });
  }, [scope.role, navigate]);

  if (scope.role !== "Owner") return null;
  return <TeamScreen />;
}
